const STRIPE_ACCOUNT_ID = import.meta.env.VITE_STRIPE_ACCOUNT_ID;
const STRIPE_TEST_MODE = import.meta.env.VITE_STRIPE_TEST_MODE === 'true';

// A tip is stored on its own hhlsync_loc row keyed `<transaction_id>-TIP`, so a
// tip row's lookup_id carries a suffix Stripe knows nothing about. Strip it, or
// the dashboard answers "no transaction found".
const stripeTransactionId = (id: string): string => id.replace(/[-_]tip$/i, '');

// The Stripe id prefixes an hhlsync_loc lookup_id can carry: `pi_` (payment
// intent), `ch_` (card charge) and `py_` (charge for every non-card payment
// method — bank/ACH, Link, and the wallets). `py_` is easy to forget and its
// absence reads as "not a Stripe donation at all": a Link gift's Status column
// came up blank even though the gift was synced (HHLTB-2738). Legacy and
// manually entered records use other id formats entirely.
const STRIPE_ID_PREFIXES = ['pi_', 'ch_', 'py_'];

export const isStripeLookupId = (id: string | null | undefined): boolean =>
    !!id && STRIPE_ID_PREFIXES.some((prefix) => id.startsWith(prefix));

export const buildStripePaymentUrl = (paymentId: string | null | undefined): string | null => {
    if (!paymentId) return null;
    const transactionId = stripeTransactionId(paymentId);
    if (!transactionId) return null;
    const modeSegment = STRIPE_TEST_MODE ? 'test/' : '';
    if (STRIPE_ACCOUNT_ID) {
        return `https://dashboard.stripe.com/${STRIPE_ACCOUNT_ID}/${modeSegment}payments/${transactionId}`;
    }
    return `https://dashboard.stripe.com/${modeSegment}payments/${transactionId}`;
};

// Payouts live under a different dashboard section than payments, and only real
// Stripe payouts (`po_`) exist there — mock/test payouts are local records.
export const buildStripePayoutUrl = (payoutId: string | null | undefined): string | null => {
    if (!payoutId || !payoutId.startsWith('po_')) return null;
    const modeSegment = STRIPE_TEST_MODE ? 'test/' : '';
    if (STRIPE_ACCOUNT_ID) {
        return `https://dashboard.stripe.com/${STRIPE_ACCOUNT_ID}/${modeSegment}payouts/${payoutId}`;
    }
    return `https://dashboard.stripe.com/${modeSegment}payouts/${payoutId}`;
};
